import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { SERVER_URL } from '@core/core.tokens';
import { FileJson, InputJson } from '@core/models/built/session-step-value-json.model';
import { SessionStepValueType } from '@core/models/built/session-step-value-type.enum';
import { SessionStep, SessionStepValue } from '@core/models/session.model';
import { filterTruthy, log } from '@utils';
import { DateTime } from 'luxon';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  templateUrl: './create-pdf-session.component.html',
  styles: [
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreatePdfSessionComponent implements OnChanges {

  @Input() step!: SessionStep;

  @Output() commitAndNext = new EventEmitter<SessionStep>();

  inputForm: FormGroup = this.fb.group({
    value: [[], [Validators.required]]
  });

  private step$$ = new BehaviorSubject<SessionStep | undefined>(undefined);
  step$ = this.step$$.pipe(filterTruthy());

  files$ = this.step$.pipe(
    map(step => step.values?.map(v => v.value as FileJson)),
    filterTruthy()
  );
  pdf$ = this.files$.pipe(
    map(files => files.length === 1 ? files[0] : undefined)
  );
  list$ = this.files$.pipe(
    map(files => files.length > 1 ? files : [])
  );

  constructor(
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
    @Inject(SERVER_URL) public serverUrl: string
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.step) {
      this.step$$.next(changes.step.currentValue);
    }
  }

  submit(step: SessionStep) {
    const now = DateTime.local();
    const value: SessionStepValue = {
      workflowId: step.workflowId,
      workflowStepId: step.workflowStepId,
      sessionId: step.sessionId,
      timestamp: now.toJSDate(),
      type: SessionStepValueType.inputBoolean,
      value: { input: true } as InputJson
    };
    this.commitAndNext.emit({ ...this.step, completedOn: now.toJSDate(), values: [...(this.step.values || []), value] });
  }

}
